<div class="bart">
  <div class="head">
    <div class="no-border body hair hair1"></div>
    <div class="no-border body hair hair2"></div>
    <div class="no-border body hair hair3"></div>
    <div class="no-border body hair hair4"></div>
    <div class="no-border body hair hair5"></div>
    <div class="no-border body hair hair6"></div>
    <div class="no-border body hair hair7"></div>
    <div class="no-border body hair hair8"></div>
    <div class="no-border body hair hair9"></div>
    <div class="body mouth-lip2"></div>
    <div class="no-border body head-left1"></div>
    <div class="no-border body head-left2"></div>
    <div class="no-border body head-left3"></div>
    <div class="no-border body head-left4"></div>
    <div class="no-border body head-left5"></div>
    <div class="no-border body head-left6"></div>
    <div class="no-border body head-left7"></div>
    <div class="body eyelid"></div>
    <div class="no-border body mouth"></div>
    <div class="body mouth-lip"></div>
    <div class="no-border body head-right2"></div>
    <div class="no-border body head-right1"></div>
    <div class="no-border body head-right3"></div>

    <!-- The ear -->
    <div class="body ear">
      <div class="no-border inner1"></div>
      <div class="no-border inner2"></div>
      <div class="no-border body clip"></div>
    </div>

    <!-- The right eye -->
    <div class="right-eye">
      <div class="no-border right-eye-pupil"></div>
      <div class="no-border body eyelid-top"></div>
      <div class="no-border body eyelid-bottom"></div>
    </div>

    <!-- The nose -->
    <div class="no-border body nose"></div>
    <div class="body nose-tip"></div>

    <!-- The left eye -->
    <div class="left-eye">
      <div class="no-border left-eye-pupil"></div>
      <div class="no-border body eyelid-top"></div>
      <div class="no-border body eyelid-bottom"></div>
    </div>

    <div class="no-border mouth-smile"></div>
  </div>
</div>
